var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.logged)?_c('div',{staticClass:"backend__container"},[(_vm.displayToast)?_c('PToast',_vm._b({},'PToast',_vm.toast,false)):_vm._e(),_c('HeaderComponent'),_c('Sidebar'),_c('MainContent'),_c('FooterComponent')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }